import React, { Component } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Container from "../Container/Container";
import "./Login.css";
import LoginRequest from "../../request/LoginRequest";
import ColorHelper from "../../helper/ColorHelper";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button, LabelInput } from "global-components-library";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      titleColorStyle: null,
      showModal: false,
      msg: null,
    };
    this.onNameChanged = this.onNameChanged.bind(this);
  }

  componentDidMount() {
    let colorHelper = ColorHelper.getInstance();
    this.setState({
      titleColorStyle: colorHelper.getLoginTitleColor(),
      buttonColorStyle: colorHelper.getButtonColorStyle(),
    });
  }

  onNameChanged = (value) => {
    this.setState({ userName: value });
  };

  onNameCompleted = () => {
    if (this.state.userName !== "") {
      
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      let domain = urlParams.get("domain");
      Promise.resolve(
        LoginRequest.CreateSession(this.state.userName, domain)
      ).then((resp) => {
        if (resp && resp.children[0] && resp.children[0].attributes) {
          let attributes = resp.children[0].attributes;
          if (parseInt(attributes.agentId.value) > 0) {
            this.props.onNameFilled({ userName: this.state.userName });
            LoginRequest.CreateChat(attributes.session.value);
            console.log('dev log',attributes);
            this.props.onSessionStart(
              attributes.session.value,
              attributes.agentId.value,
              attributes.agentName.value,
              attributes.message.value,
              attributes.timeOut.value,
              attributes.chatId.value,
              attributes.maxImgToSend.value
            );
          } else {
            if (attributes.responseStatus.value === "1") {
              LoginRequest.CreateChat(attributes.session.value);
              this.props.onSessionStart(
                attributes.session.value,
                -1,
                attributes.agentName.value,
                attributes.message.value,
                0
              );
            } else {
              this.setState({ showModal: true, msg: attributes.message.value });
            }
          }
        }
      });
    }
  };

  modalErrors = () => {
    const { buttonColorStyle } = this.state;
    const { login: loginLabels } = window["labels"];
    return (
      <Modal isOpen={this.state.showModal}>
        <ModalHeader>{loginLabels.modalTitle}</ModalHeader>
        <ModalBody>
          {this.state.msg ? this.state.msg : loginLabels.modalBody}
        </ModalBody>
        <ModalFooter>
          <button
            className="modal-error-btn"
            onClick={() => this.setState({ showModal: false })}
            style={buttonColorStyle}
          >
            {loginLabels.modalBtn}
          </button>
        </ModalFooter>
      </Modal>
    );
  };

  render() {
    // const { titleColorStyle } = this.state;
    const titleColorStyle = {
      color: 'rgb(52, 52, 103)'
    };
    const { login: loginLabels } = window["labels"];
    return (
      <div className="login-container">
        {this.modalErrors()}
        <Header minimize={this.props.minimize} />
        <Container>
          <div className="login-body">
            <div className="title" style={titleColorStyle}>
              {loginLabels.chatServices}
            </div>
            <div className="subtitle">{loginLabels.schedule}</div>
            <div className="subtitleSchedul">{loginLabels.hours}</div>
            <div className="subtitleSchedul">{loginLabels.hourstwo}</div>
            <div className="form">
            <div className="lbl">{loginLabels.lblName}</div>
              <LabelInput 
                type="text"
                value={this.state.userName}
                label={loginLabels.namePlaceholder}
                placeholder={loginLabels.namePlaceholder} 
                onChange={this.onNameChanged}
                onEnter={this.onNameCompleted}
                onlyAlphanumeric={true}
                />
              <Button color="primary" onClick={this.onNameCompleted} disabled={!this.state.userName.trim()}>
                {loginLabels.btnStart}
              </Button>
            </div>
          </div>
        </Container>
        <Footer />
      </div>
    );
  }
}
